export default __webpack_public_path__ + "static/media/ISEO CLASS 7 SYLLABUS.ba04a079.pdf";